export default "__VITE_ASSET__CKiKqtG7__"